(() => {
  const initialize = (root) => {
    if (!root || root.dataset.skyFooterReady === 'true') return;
    root.dataset.skyFooterReady = 'true';
    const groups = [...root.querySelectorAll('.sky-footer__links details')];
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const sync = (event) => groups.forEach((group) => { group.open = !event.matches; });
    sync(mobileQuery);
    mobileQuery.addEventListener?.('change', sync);
  };

  const initializeAll = (scope = document) => scope.querySelectorAll('.sky-footer').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll());
  else initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
